// Tooltip riche réutilisable (fond blanc, ombre, large) + wrapper "demande vs RDV direct".
// Partagé entre les cards de formule (/pro) et le tableau comparatif (FormulesSection).
import { Box, Tooltip, Typography, tooltipClasses, type TooltipProps } from '@mui/material';
import { styled } from '@mui/material/styles';

// enterTouchDelay=0 → sur mobile le tooltip s'ouvre au tap (pas en appui long).
// leaveTouchDelay long → laisse le temps de tapoter le lien "cliquez ici".
export const RichTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip enterTouchDelay={0} leaveTouchDelay={4000} {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#fff',
    color: '#1a1a1a',
    maxWidth: 280,
    padding: 14,
    borderRadius: 12,
    border: '1px solid #e5e7eb',
    boxShadow: '0 10px 30px rgba(0,0,0,0.14)',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#fff',
    '&::before': { border: '1px solid #e5e7eb' },
  },
}));

// Rich card au hover : intro libre + ligne standard "Pour voir la différence… cliquez ici".
// Si onOpenHowItWorks absent (ex : LP), le lien devient une mention statique.
export const RdvInfoTooltip = ({
  intro,
  onOpenHowItWorks,
  children,
}: {
  intro: string;
  onOpenHowItWorks?: () => void;
  children: React.ReactElement;
}) => (
  <RichTooltip
    arrow
    placement="top"
    title={
      <Box>
        <Typography variant="body2" sx={{ lineHeight: 1.6, mb: 1 }}>
          {intro}
        </Typography>
        <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
          Pour voir la différence entre demande et rendez-vous direct
          {onOpenHowItWorks ? (
            <>
              ,{' '}
              <Box
                component="span"
                onClick={onOpenHowItWorks}
                sx={{
                  color: 'primary.main',
                  fontWeight: 700,
                  cursor: 'pointer',
                  textDecoration: 'underline',
                }}
              >
                cliquez ici
              </Box>
              .
            </>
          ) : (
            ' (voir les méthodes ci-dessus).'
          )}
        </Typography>
      </Box>
    }
  >
    {children}
  </RichTooltip>
);
